import { menu } from './menu';
import { router } from './router';

export const OjeteVozy = {
	router,
	menu,
};
